module.exports = __webpack_public_path__ + "img/banner_ksh.5583db19.jpg";